import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/inputs/get-locations-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterLocationListContext } from '../../location.context';
import { LocationListFilterFormStep1Controller } from '../location-list-filter-form-step-1/location-list-filter-form-step-1.controller';

export interface LocationListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetLocationsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetLocationsPaginatedModel>;
  onCancel: () => void;
}

export const LocationListFilterFormController = (
  props: LocationListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterLocationListContext();

  return (
    <MultiStepFormProvider<GetLocationsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: ['networkId'],
          component: <LocationListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
